// extracted by mini-css-extract-plugin
module.exports = {"validIcon":"styles_validIcon__fRR2j","dash-check":"styles_dash-check__MA7qv"};